export default "__VITE_ASSET__4d8a82cb__"